<div id="feedback-dialog-container">

  <form [formGroup]="userFeedback.feedbackForm"
        (ngSubmit)="userFeedback.sendFeedback()">

    <div id="dialogTitle">
      <div>
        <mat-icon svgIcon="feedback"></mat-icon>
      </div>
      <span>{{ 'FEEDBACK.TITLE' | translate }}</span>
    </div>

    <div id="dialogContent">

      <div id="questionContainer">
        {{ 'FEEDBACK.PROPOSITION' | translate }}
      </div>

      <div id="featureContainer">
        <span>{{ 'FEATURE' | translate }}</span>
        <mat-form-field appearance="fill">
          <mat-select formControlName="category">
            @for (category of categories; track category) {
              <mat-option [value]="category">
                {{ ('FEEDBACK.' + (category.toUpperCase())) | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div id="ratingContainer">
        <div id="ratingQuestion">
          {{ 'FEEDBACK.RATING_QUESTION' | translate }}
        </div>
        <div id="emoticonContainer">
          @for (emoticon of userFeedback.emoticonsList; track emoticon; let i = $index) {
            <span class="emoticonItem">
              <input type="radio"
                     id="rating_{{userFeedback.getRating(i)}}"
                     name="rating"
                     formControlName="rating"
                     value="{{userFeedback.getRating(i)}}">
                <label for="rating_{{userFeedback.getRating(i)}}"
                       [innerHTML]="emoticon"
                       class="emoticon">
                </label>
              </span>
          }
        </div>
      </div>

      <div id="commentContainer">
        <div class="comment-label">{{ 'FEEDBACK.TEXT_AREA_PLACEHOLDER' | translate }}</div>
        <mat-form-field class="custom-mat-form-field" appearance="fill">
            <textarea class="comment-text-area"
                      matInput
                      appGxInput
                      formControlName="comment">
            </textarea>
        </mat-form-field>
      </div>


    </div>

    <div id="buttonContainer" align="end">
      <button matButton="outlined"
              id="cancelButton"
              mat-dialog-close
              tabindex="-1"
              [mat-dialog-close]="null">{{ 'CANCEL' | translate }}
      </button>

      <span matTooltip="{{'FEEDBACK.BUTTON_TOOLTIP' | translate}}"
            matTooltipPosition="below"
            [matTooltipDisabled]="!userFeedback.feedbackForm.invalid">
          <button mat-flat-button color="primary"
                  tabindex="-1"
                  type="submit"
                  [mat-dialog-close]
                  [disabled]="userFeedback.feedbackForm.invalid">{{ 'SEND' | translate }}
          </button>
        </span>

    </div>
  </form>

</div>
